enum StatutVictime {
  Titulaire = "TITULAIRE",
  Contractuel = "CONTRACTUEL",
}

export default StatutVictime;
